import { IconTrash } from "@tabler/icons-react";
import React from "react";
import { Modal, Button } from "react-bootstrap";

const typeColors = {
    //danger: 'red',
    success: 'green',
}

const ConfirmationModal = ({
  show,
  onHide,
  message,
  onConfirm,
  type = "success",
}) => {
  const handleConfirm = () => {
    onConfirm();
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header className="justify-content-center" closeButton>
        <Modal.Title>Do you want to delete this User?</Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center">
        <span className="trash_avtar bg-pink-lt  rounded-circle"> <IconTrash stroke={1} /> </span>
        <p style={{ color: typeColors[type] }} >{message}</p>
      </Modal.Body>

      <Modal.Footer className="justify-content-center">
        <Button variant={type} onClick={handleConfirm}>
          Confirm
        </Button>
        <Button variant="outline-danger" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
